import { GlobalStoreCtx } from '@/stores/GlobalStore';
import { stopBubbling } from '@/utils/functions/eventHandler/stopBubbling';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { pipe } from 'ramda';
import React, { useContext, useEffect } from 'react';

import DeepLinkBanner from './DeepLinkBanner/DeepLinkBanner';
import styles from './SmartBanner.module.scss';
import type { IAppBannerImage } from '@/configs/interfaces/IAppBannerImage';

const getImagePath = (image?: IAppBannerImage): string => {
  const IMAGE_PATH_FALLBACK = '/static/images/nol/sunny-web/AppDownload_SVG.svg';
  const now = new Date();
  const isPromotionPeriod = (): boolean =>
    !!(image?.promotion?.from && image?.promotion?.to) &&
    now >= new Date(image.promotion.from) &&
    now <= new Date(image.promotion.to);

  return (isPromotionPeriod() ? image?.promotion?.path : image?.defaultPath) || IMAGE_PATH_FALLBACK;
};

const SmartBanner: React.FC<{ className?: string }> = ({ className }) => {
  const globalStore = useContext(GlobalStoreCtx);

  useEffect(() => {
    setTimeout(() => {
      globalStore.smartBannerInitialized = true;
    });
  }, []);

  if (globalStore.IsPc || !globalStore.ShowSmartBanner) {
    return null;
  }

  return (
    <section className={clsx(styles.container, className)}>
      <button className={styles.close} onClick={pipe(stopBubbling, globalStore.closeSmartBanner)}>
        <i />
      </button>
      <DeepLinkBanner imagePath={getImagePath(globalStore.SmartBanner?.image)} />
    </section>
  );
};

export default observer(SmartBanner);
